export default __webpack_public_path__ + "static/media/Intry-Logo-Black-Small.b4c8ad01.png";